import { add, divide, multiply, productTimesX, subtract, sum } from '@/js/model/Functions';
import { Model } from '@/js/model/Model';
import { RemoteDateSeries } from '@/js/model/DataSeries';


const idLookup = {
  'iPhone: Net Sales': '3314878374',
  'Mac: Net Sales': '7946929191',
  'iPad: Net Sales': '1891630593',
  'Wearables: Net Sales': '1086209886',
  'Services: Net Sales': '8073064543',
  'Other Products: Net Sales': '4747935358',
  'iPod: Net Sales': '3929308631',
  'Accessories: Net Sales': '1115532880',
  'Total Net Sales': '4037321092',
  'OpEx: R&D': '117818420',
  'OpEx: SGA': '3708565828',
  'Taxes': '5341735633',
  'Net Income': '8405208644',
  'EPS': '7411109961',
  'Shares': '6713296305',
  'Stock Split Adj': '8749201652',
  'Price': '6240932624',
  'Products: COGS': '7717622748',
  'Services: COGS': '6952885427',
  'Overall: COGS': '1183479312',
  'P/E Ratio': '3700575613',
}

export var modelAAPL = new Model('AAPL Stock Model');

// Add all remote actual data into the model
let actualValues = [
  'iPhone: Net Sales',
  'Mac: Net Sales',
  'iPad: Net Sales',
  'Wearables: Net Sales',
  'Services: Net Sales',
  'Other Products: Net Sales',
  'Overall: COGS',
  'OpEx: R&D',
  'OpEx: SGA',
  'Taxes',
  'Shares',
  'Stock Split Adj',
  'P/E Ratio'];

for (const name of actualValues) {
  let c = modelAAPL.addComponent(name);
  let remoteSeries = new RemoteDateSeries(idLookup[name]);

  c.setData(remoteSeries);  
}


// Add derived series that use others as inputs
modelAAPL.addComponentWithMethod('Overall: Net Sales',
  sum,
  {args: ['iPhone: Net Sales','Mac: Net Sales','iPad: Net Sales',
  'Wearables: Net Sales','Services: Net Sales','Other Products: Net Sales']}
);

modelAAPL.addComponentWithMethod('Overall: Margin',
  subtract,
  {a: 'Overall: Net Sales', b: 'Overall: COGS'}
);

modelAAPL.addComponentWithMethod('OpEx',
  add,
  {a: 'OpEx: R&D', b: 'OpEx: SGA'}
);

modelAAPL.addComponentWithMethod('Operating Income',
  subtract,
  {a: 'Overall: Margin', b: 'OpEx'}
);

modelAAPL.addComponentWithMethod('Net Income',
  subtract,
  {a: 'Operating Income', b: 'Taxes'}
);

modelAAPL.addComponentWithMethod('Adj Shares',
  multiply,
  {a: 'Shares', b: 'Stock Split Adj'}
);

modelAAPL.addComponentWithMethod('EPS',
  divide,
  {a: 'Net Income', b: 'Adj Shares'}
);

modelAAPL.addComponentWithMethod('Price',
  productTimesX,
  {args: ['EPS','P/E Ratio'], constant: 4}
);

export const template = {
  'Label': 'Apple AAPL Stock Valuation',
  'Category': 'Stocks',
  'Description': 'Valuation model for $AAPL to estimate a target price',
  'model': modelAAPL
}